[
  { "label": "Delivery", "value": "DEL" },
  { "label": "Collection", "value": "COL" }
]
